<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">

        <div class="card border-0 shadow-sm overflow-hidden w-100 mb-4 license-renew-card">
          <div class="card-body text-white p-4 p-lg-5 license-renew-card__body">
            <div class="row align-items-center g-4">
              <div class="col-lg-7">
                <span class="license-renew-card__badge">
                  <i class="fas fa-tag me-1"></i>
                  50% de descuento · 3 meses
                </span>
                <h4 class="license-renew-card__title mb-2">¡Renueva tu licencia ahora!</h4>
                <p class="license-renew-card__subtitle mb-0">
                  Promoción especial aplicada: licencia por <strong>3 meses</strong> con
                  <strong>50% de descuento</strong>. Sigue disfrutando de todos los beneficios de Mi Stock.
                </p>
              </div>

              <div class="col-lg-5">
                <div class="license-renew-card__pricing">
                  <div class="license-renew-card__pricing-row">
                    <span class="license-renew-card__label">Descuento</span>
                    <span class="license-renew-card__discount">3 meses · 50% aplicado</span>
                  </div>
                  <div class="license-renew-card__pricing-row license-renew-card__pricing-row--total">
                    <span class="license-renew-card__label">Valor a pagar</span>
                    <span class="license-renew-card__amount">{{ formattedPayAmount }}</span>
                  </div>
                  <button
                    type="button"
                    class="btn btn-light w-100 license-renew-card__btn"
                    @click="payment"
                  >
                    <i class="fas fa-credit-card me-2"></i>
                    Renovar ahora
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="card">
          <div class="card-header pb-0">
            <h6>Historial de pagos</h6>

          </div>

         

          
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Pago id</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Valor</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Fecha de pago</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Fecha de vigencia</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr  v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.payment_id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ parseFloat(value?.amount ).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatDateOnly(value?.created_at) }} 
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ formatDateOnly(value?.coverage_month) }} 
                    </td>
                    <td class="align-middle text-center text-sm">
                      <span 
                        class="badge badge-sm"
                        :class="{
                          'bg-gradient-warning': value.status === 'pending',  // Pendiente
                          'bg-gradient-danger': value.status === 'rejected',  // Producción
                          'bg-gradient-success': value.status === 'paid',  // Terminado
                        }"
                      >
                        {{
                          value.status === 'pending' ? 'Pendiente' :
                          value.status === 'rejected' ? 'Rechazado' :
                          value.status === 'paid' ? 'Pagado': 'Anulado'
                        }}
                      </span>
                    </td>

                    
                  </tr>
                
                  <tr v-if="data.length === 0">
                    <td colspan="5" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

            </div>

          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import Swal from 'sweetalert2';
import { formatDateOnly } from '@/helpers/dateFormat';

export default {
  name: 'ProjectsTable',
  data() {
    return {
      data: [],
      payAmount: 0,
      discountLabel: '3 meses · 50% aplicado',
    };
  },
  computed: {
    formattedPayAmount() {
      return Number(this.payAmount).toLocaleString('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
  },
  methods: {
    formatDateOnly,
    async fetchData() {
      const response = await this.$store.dispatch('payments/getAll'); 
      this.data = response?.data?.data??[];
    },
    async payment() {
      try {
        const response = await this.$store.dispatch('payments/create');
        const data = response?.data;

        if (data?.formUrl) {
          window.location.href = data.formUrl;
          return;
        }

        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: data?.message || 'Error al generar pago',
        });
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          'No se pudo iniciar el pago. Intente nuevamente.';

        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: message,
        });
      }
    },
  },
  async mounted() {
    this.fetchData();
    this.payAmount = await this.$store.dispatch('payments/getAmount');
  },
};
</script>

<style scoped>
.license-renew-card__body {
  background: linear-gradient(135deg, #0d6efd 0%, #5b21b6 55%, #6610f2 100%);
}

.license-renew-card__badge {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.85rem;
  margin-bottom: 1rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.28);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.license-renew-card__title {
  font-weight: 700;
  color: #fff;
}

.license-renew-card__subtitle {
  max-width: 38rem;
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.95rem;
  line-height: 1.55;
}

.license-renew-card__pricing {
  padding: 1.25rem 1.35rem;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(8px);
}

.license-renew-card__pricing-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 0.85rem;
  margin-bottom: 0.85rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
}

.license-renew-card__pricing-row--total {
  align-items: flex-end;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: none;
}

.license-renew-card__label {
  font-size: 0.82rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.82);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.license-renew-card__discount {
  font-size: 0.95rem;
  font-weight: 700;
  color: #fff;
  text-align: right;
}

.license-renew-card__amount {
  font-size: 2rem;
  font-weight: 800;
  line-height: 1;
  color: #fff;
  text-align: right;
  white-space: nowrap;
}

.license-renew-card__btn {
  font-weight: 700;
  border-radius: 999px;
  padding: 0.75rem 1.25rem;
  color: #4c1d95;
}

.license-renew-card__btn:hover {
  color: #3b1578;
  transform: translateY(-1px);
}

@media (max-width: 991.98px) {
  .license-renew-card__amount {
    font-size: 1.65rem;
  }
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.page-item {
  margin: 0 5px;
}
.active {
  font-weight: bold;
}
</style>